import { createSlice } from "@reduxjs/toolkit";

type ThemeData = Record<string, unknown>;

interface ThemeState {
  themeData: ThemeData | null;
  loading: boolean;
  error: unknown;
}

const initialState: ThemeState = {
  themeData: null,
  loading: false,
  error: null,
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setAppTheme(state, action) {
      state.themeData = action.payload;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { setAppTheme } = themeSlice.actions;
export default themeSlice.reducer;
